import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { formatReportNumber } from '../../utils/CommonFunctions';
import { useFetchTouApplicable } from './Hooks';

const TouRatesHint = ({ operatorId }) => {
  const { t } = useTranslation('reportPage');
  const lastMonth = dayjs().subtract(1, 'month');
  const from = lastMonth.startOf('month').format('YYYY-MM-DD');
  const to = lastMonth.endOf('month').format('YYYY-MM-DD');
  const { data, isLoading } = useFetchTouApplicable(operatorId, from, to);
  const monthInfo = data?.months?.[0];

  if (!operatorId) return <span>—</span>;
  if (isLoading) return <span>...</span>;
  if (!monthInfo || !monthInfo.isComplete) {
    return (
      <div className="text-sm">
        <span className="text-orange-600">
          {t('touNotComplete') || 'TOU tariff incomplete for last month.'}
        </span>{' '}
        <Link to="/dashboard/tou-pricing">{t('touPricingLink') || 'Open TOU Pricing'}</Link>
      </div>
    );
  }

  return (
    <div className="text-sm">
      <div>
        {t('touRates') || 'TOU rates'}:{' '}
        {(monthInfo.rates || []).map((r) => formatReportNumber(r)).join(', ')}
      </div>
      <div>
        {t('touAvgRate') || 'Avg rate'}: {formatReportNumber(monthInfo.weightedAvgRate)}
      </div>
      <Link to="/dashboard/tou-pricing">{t('touPricingLink') || 'Open TOU Pricing'}</Link>
    </div>
  );
};

export default TouRatesHint;
